import { Spinner } from 'reactstrap';
import icSaveSuccess from '@/shared/ui/icons/Components/ic-saved-success.svg';
import useProgressLoading from './useProgressLoading';
import './styles.scss';

type ProgressLoadingProps = {
  isStartedAiProcessing?: boolean;
  isSmall?: boolean;
};

const ProgressLoading = ({
  isSmall = false,
  isStartedAiProcessing = false,
}: ProgressLoadingProps) => {
  const { isSaved } = useProgressLoading();

  return isSmall ? (
    <div className="save-report-progress-loading">
      {isSaved ? (
        <div className="save-btn-loading">
          <img src={icSaveSuccess} alt="save success" />
          <span>Saved</span>
        </div>
      ) : (
        <div className="save-btn-loading --disabled">
          <Spinner className="save-btn-loading__spinner">
            {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
            {''}
          </Spinner>
          <span>Saving...</span>
        </div>
      )}
    </div>
  ) : (
    <div className="not-started-holter-loading">
      <Spinner className="not-started-holter-loading__spinner">
        {/* eslint-disable-next-line react/jsx-curly-brace-presence -- must be a literal empty string, not omitted: reactstrap's Spinner defaultProps falls back to children="Loading..." when children is undefined */}
        {''}
      </Spinner>
      <div className="not-started-holter-loading__text">
        {!isStartedAiProcessing ? (
          <>
            <div>Initializing...</div>
            <div>Please wait</div>
          </>
        ) : (
          'Loading data...'
        )}
      </div>
    </div>
  );
};

export default ProgressLoading;
